import React, { useState, useEffect, useRef } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

type LabelsProps = {
    content: {
        list?: (string | null)[];
        itemClass?: string;
    };
};

const Labels = ({ content }: LabelsProps) => {
    const { list = [], itemClass = '' } = content;
    const [labels, setLabels] = useState<(string | null)[]>(list);
    const wrapRef = useRef<HTMLDivElement>(null);
    const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

    useEffect(() => {
        if (wrapRef.current && list.length) {
            const wrapOffsetWidth = wrapRef.current.offsetWidth;
            const wrapScrollWidth = wrapRef.current.scrollWidth;

            if (wrapScrollWidth > wrapOffsetWidth && itemRefs.current.length) {
                let oversizeFlag = false;
                let oversizeIndex = 0;

                itemRefs.current.reduce((prevLen, current, currentIndex) => {
                    let currentLen = 0;

                    if (current) {
                        currentLen = current.offsetWidth;
                    }

                    const totalLen = prevLen + currentLen;

                    if (totalLen > wrapOffsetWidth && !oversizeFlag) {
                        oversizeFlag = true;
                        oversizeIndex = currentIndex;
                    }

                    return totalLen;
                }, 0);

                if (oversizeFlag && oversizeIndex > 0) {
                    setLabels(list.splice(0, oversizeIndex));
                }
            }
        }
    }, [list]);

    return labels && Array.isArray(labels) && labels.length ? (
        <div className={styles.wrap} ref={wrapRef}>
            {labels.map((item, index) => {
                return (
                    <div
                        className={`${styles.item} ${itemClass}`}
                        key={item}
                        ref={(ref) => {
                            itemRefs.current[index] = ref;
                        }}>
                        {item}
                    </div>
                );
            })}
        </div>
    ) : null;
};

export default errorBoundary(Labels);
